// extracted by mini-css-extract-plugin
module.exports = {"HeaderWrapper":"Header_HeaderWrapper__31t5F","Logo":"Header_Logo__q1Zi3","Brand":"Header_Brand__1G3dD"};